import { render, staticRenderFns } from "./DesignPanel.vue?vue&type=template&id=48a80b19&scoped=true&"
import script from "./DesignPanel.vue?vue&type=script&lang=js&"
export * from "./DesignPanel.vue?vue&type=script&lang=js&"
import style0 from "./DesignPanel.vue?vue&type=style&index=0&id=48a80b19&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a80b19",
  null
  
)

export default component.exports